export const detectSource = props => {
    if (props?.location?.state?.type === 'edit' || window.location?.search?.includes('edit')){
        return 'edit';
    } else if (window.location?.search?.includes('duplicate') || props?.location?.state?.type === 'duplicate'){
        return 'duplicate';
    }   
    return 'show';
}